// @ts-nocheck
// Ignore - attributes doesn't exist on type
// TODO: add to type and do additional checks
import { useFormContext } from "react-hook-form";
import { Alert } from "../Alert";
import { getErrorTypeText } from "./getErrorTypeText";

interface FormErrorsProps {
  applyPadding?: boolean;
}

export function FormErrors({ applyPadding = false }: FormErrorsProps) {
  const {
    formState: { errors },
  } = useFormContext();

  const getErrorText = (errorKey: string, errorObject: any) => {
    const error = errorObject[errorKey];
    if (error) {
      if (error?.message) {
        return error.message as string;
      } else {
        if (error?.ref?.attributes?.["aria-label"]) {
          return `${
            error.ref.attributes["aria-label"].value
          } is ${getErrorTypeText(error?.type as string)}`;
        } else {
          return `${errorKey} is ${getErrorTypeText(error?.type as string)}`;
        }
      }
    }
    return `is ${getErrorTypeText(error?.type as string)}`;
  };

  const getFlatErrors = (errors: any, parentKey = "") => {
    const flatErrors: Record<string, any> = {};
    Object.keys(errors).forEach((key) => {
      const nestedKey = parentKey ? `${parentKey}.${key}` : key;
      if (errors[key]?.type || errors[key]?.message) {
        flatErrors[nestedKey] = errors[key];
      } else if (typeof errors[key] === "object") {
        Object.assign(flatErrors, getFlatErrors(errors[key], nestedKey));
      }
    });
    return flatErrors;
  };

  const flatErrors = getFlatErrors(errors);
  const errorKeys = Object.keys(flatErrors);

  return errorKeys.length > 0 ? (
    applyPadding ? (
      <div className="p-4">
        <Alert
          severity="error"
          title="Validation Error"
          message={errorKeys.map((key) => getErrorText(key, flatErrors))}
        />
      </div>
    ) : (
      <Alert
        severity="error"
        title="Validation Error"
        message={errorKeys.map((key) => getErrorText(key, flatErrors))}
      />
    )
  ) : null;
}
